import React from 'react'
// apparently eslint doesn't parse arg defaults
import defaultStyles from './UnderlineSelector.scss' // eslint-disable-line
import {Map} from 'immutable'
import cx from 'classnames'
/*
nice selector widget
*/
export const UnderlineSelector = ({options = Map(), selected = null, styles, className, onSelectionChanged}) => {
  const styles_ = styles || defaultStyles
  return (
    <div className={className || styles_.UnderlineSelector}>
      {options.map((label, key) =>
        <a key={key} onClick={() => onSelectionChanged(key)} className={cx(styles_.option, key === selected && styles_.selected)}>
          {label}
        </a>).toIndexedSeq()}
    </div>
  )
}
